export default __webpack_public_path__ + "static/media/corporate1.c1e94abd.jpg";